export const HOME_PATH = "/";
export const DETAIL_PATH = "/detail/:id";
export const ADD_FORM_PATH = "/request";